export default __webpack_public_path__ + "static/media/Business-documents-management-login-image.ca001e90.png";